export class NumberHelper {
    /**
     * Return parsed number by parseInt
     * @param {string} numberInString a string to be parsed into number
     * @returns {number} a parsed number
     */
    public static parseFromString(numberInString: string): number {
        const parsedNumber = parseInt(numberInString);

        if (isNaN(parsedNumber) || IsNullOrUndefined(parsedNumber)) {
            return 0;
        }
        else {
            return parsedNumber;
        }
    }

    /**
     * Return true if a number is not NaN, null, or undefined, and its type is number
     * @param {number} number
     * @returns {boolean}
     */
    public static isValidNumber(number: number): boolean {
        if (typeof (number) !== "number") {
            return false;
        }

        if (isNaN(number)) {
            return false;
        }

        if (IsNullOrUndefined(number)) {
            return false;
        }

        return true;
    }
}
